import type {
	FieldErrorsImpl,
	FieldValues,
	FieldError as HookFieldError,
	Merge,
} from "react-hook-form";

export default function FieldError<T extends FieldValues>({
	error,
	className,
}: {
	error?: HookFieldError | Merge<HookFieldError, FieldErrorsImpl<T>>;
	className?: string;
}) {
	return (
		<p
			className={`pt-1 text-sm text-red-700 leading-tighter block py-0 ${className || ""}`}
		>
			{typeof error?.message === "string"
				? error.message
				: error?.message?.toString()}
		</p>
	);
}
